var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTronLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5500_23163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2344 6.02478C18.2969 5.15915 17 3.83728 15.9438 2.89978L15.8813 2.85603C15.7773 2.77252 15.66 2.70703 15.5344 2.66228V2.66228C12.9875 2.18728 1.13438 -0.0283479 0.903125 -0.000222886C0.838328 0.00885213 0.776391 0.0323454 0.721875 0.0685271L0.6625 0.115402C0.589389 0.189652 0.53386 0.279353 0.5 0.377902L0.484375 0.418527V0.640402V0.674777C1.81875 4.3904 7.0875 16.5623 8.125 19.4185C8.1875 19.6123 8.30625 19.981 8.52813 19.9998H8.57813C8.69688 19.9998 9.20313 19.331 9.20313 19.331C9.20313 19.331 18.2531 8.35603 19.1688 7.18728C19.2873 7.04331 19.3919 6.88845 19.4813 6.72478C19.5041 6.59671 19.4933 6.46492 19.45 6.34225C19.4068 6.21958 19.3325 6.1102 19.2344 6.02478V6.02478ZM11.525 7.3029L15.3875 4.09978L17.6531 6.18728L11.525 7.3029ZM10.025 7.09353L3.375 1.64353L14.1344 3.6279L10.025 7.09353ZM10.625 8.52165L17.4312 7.42478L9.65 16.7998L10.625 8.52165ZM2.47187 2.18728L9.46875 8.12478L8.45625 16.806L2.47187 2.18728Z",
    fill: "#FF060A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5500_23163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTronLogo);
export default __webpack_public_path__ + "static/media/TronLogo.a2f835086015e3e5b444649ac67c47d0.svg";
export { ForwardRef as ReactComponent };